export function BugFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M10.097 5.683A5.32 5.32 0 0112 5.333c.592 0 1.16.097 1.692.274l2.315-2.314a1 1 0 011.414 1.414l-1.929 1.929A5.339 5.339 0 0117.068 9H19a1 1 0 110 2h-1.667v2H19a1 1 0 110 2h-1.667v1H19a1 1 0 110 2h-2.054a5.335 5.335 0 01-9.892 0H5a1 1 0 110-2h1.667v-1H5a1 1 0 110-2h1.667v-2H5a1 1 0 110-2h1.932a5.336 5.336 0 011.425-2.229L6.293 4.707a1 1 0 011.414-1.414l2.39 2.39zM11 9a1 1 0 100 2h2a1 1 0 100-2h-2z"
      ></path>
    </svg>
  );
}
